<template>
    <el-dialog class="crossExamination" :title="diatorTitle" :visible.sync="dialogVisible" :open="handleOpen" :before-close="handleClose" width="800px" :destroy-on-close="true" :close-on-click-modal="false">
        <div class="big-title">质证三性说明公告</div>
        <div  class="text-info">三性指证据的真实性、关联性、合法性，真实性是指证据能证明案件真实的、不依赖于主观意识而存在的客观事实。关联性是指证据事实不仅是一种客观存在，而且它与案件所要查明的事实存在逻辑上的联系。合法性是指证据须由当事人按照法定程序提供，或由法定机关、法定人员按照法定的程序调查、收集和审查。</div>
        <div class="inneExaminationr">
            <div class="topExamination">
                <div class="nocrossExamination" v-if="!isRecord">
                    真实性：
                    <el-select v-model="speciality.realnessOpt" placeholder="请选择" value-key="value" @change="handleSpeciality">
                        <el-option
                        v-for="item in optionsReality"
                        :key="item.value"
                        :label="item.label"
                        :value="item">
                        </el-option>
                    </el-select>
                    合法性：
                    <el-select v-model="speciality.legalityOpt" placeholder="请选择" @change="handleSpeciality">
                        <el-option
                        v-for="item in optionsLegal"
                        :key="item.value"
                        :label="item.label"
                        :value="item">
                        </el-option>
                    </el-select>
                    关联性：
                    <el-select v-model="speciality.relevanceOpt" placeholder="请选择" @change="handleSpeciality">
                        <el-option
                        v-for="item in optionsRelevance"
                        :key="item.value"
                        :label="item.label"
                        :value="item">
                        </el-option>
                    </el-select>
                </div>
                <div class="yescrossExamination" v-else>
                    <el-table
                        :data="opinionTable"
                        border
                        style="width: 100%">
                        <el-table-column
                        label="当事人"
                        width="180"
                        align="center">
                        <template slot-scope="scope">
                            {{scope.row.userName}}({{meetingTypeEnum[scope.row.userType]}})
                        </template>
                        </el-table-column>
                        <el-table-column
                        label="真实性"
                        width="180"
                        align="center">
                        <template slot-scope="scope">
                            <span :class="scope.row.realnessType == '0' ? 'icon-check' : 'icon-check uncheck'"></span>
                        </template>
                        </el-table-column>
                        <el-table-column
                        label="合法性"
                        align="center">
                        <template slot-scope="scope">
                            <span :class="scope.row.legalityType == '0' ? 'icon-check' : 'icon-check uncheck'"></span>
                        </template>
                        </el-table-column>
                        <el-table-column
                        label="关联性"
                        align="center">
                        <template slot-scope="scope">
                            <span :class="scope.row.relevanceType == '0' ? 'icon-check' : 'icon-check uncheck'"></span>
                        </template>
                        </el-table-column>
                        <el-table-column
                        label="操作"
                        align="center">
                        <template slot-scope="scope">
                           <i @click="deleteZ(scope.row)" class="el-icon-delete"></i>
                        </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
            <div class="contentExamination">
                <div>
                    <div class="privatchat_main-title">质证意见：</div>
                    <div  class="privatchat_main1" >
                        <div v-if="isRecord" class="chat-message_list" ref="messageListBox1" id="examinationBox">
                            <ul>
                                <li v-for="msg in opinionTable" :key="msg.index" :class="{'meeting-chatroom-self': msg.id==curUserId}">
                                    <span>{{msg.userName}}（{{meetingTypeEnum[msg.userType]}}） {{msg.updateTime}}</span>
                                    <div class="infobackground">
                                        <div>质证内容：{{msg.remark ? msg.remark : '无'}}</div>
                                    </div>
                                </li>
                            </ul>
                            <div v-if="opinionTable.length === 0" class="no_list"><img alt="" :src="require('@/assets/images/no_list.png')">
                            </div>
                        </div>
                        <div v-else class="chat-message_speaking">
                            <textarea v-model="inputMessage" class="input-textarea" placeholder="请在此输入"></textarea>
                        </div>
                    </div>
                </div>
                <div v-if="!isRecord" class="chat-message_btnSend">
                    <el-button @click="onSendMessageClick()" :loading="btnSubmiting">提交</el-button>
                </div>
            </div>
        </div>
    </el-dialog>
</template>

<script>
import {addEvidence} from '@/api/user.js'
import {evidenceList,delEvidence} from '@/api/user.js'
import config from '@/config/config'
import {getStore} from '@/utils/utils.js'
import { UserRole } from "@/common/js/roleMixin.js";
export default {
    mixins: [UserRole],
    components: {
    },
    props: ['createRoomData', 'addEvidenceData', 'isCrossExaminationRecord'],
    data() {
        return {
            // 用来接收外部传值，与isCrossExaminationRecord同义
            isRecord: false,
            diatorTitle: '质证',
            dialogVisible: true,
            isSubmitedOpinion: false,
            opinionTable: [],
            optionsReality: [{
                value: '0',
                label: '真实'
            }, {
                value: '1',
                label: '不真实'
            }],
            optionsLegal: [{
                value: '0',
                label: '合法'
            }, {
                value: '1',
                label: '不合法'
            }],
            optionsRelevance: [{
                value: '0',
                label: '关联'
            }, {
                value: '1',
                label: '不关联'
            }],
            speciality: {
                realnessOpt: {
                    value: '',
                    label: '真实'
                },
                legalityOpt: {
                    value: '',
                    label: '合法'
                },
                relevanceOpt: {
                    value: '',
                    label: '关联'
                }
                // realnessType: '0',
                // realnessName: '真实',
                // legalityName: '合法',
                // legalityType: '0',
                // relevanceName: '关联',
                // relevanceType: '0',
            },
            btnSubmiting: false,
            inputMessage: '',   //发送消息
            userToken: '',  //token
            msgs: [],    //消息列表
            ws: '',
            socketStatus: false,
            messagePageIndex: 1,
            messageTotalPages: '',
            onceLoadMessage: true,
            messageListLoad: true,
            messageListBody:'',
            roomId: [],
            fileListitem: [],   //当前质证文件
            loginMemberType: '', //当前登陆者角色
            isMedia: true,
            curUserId: '',
            curroomid: null,
            showRecord: true,
            // isMyself: false
        }
    },
    watch: {
        isCrossExaminationRecord: {
            immediate: true,
            handler(value) {
                this.isRecord = value
                console.log('watch', value)
                this.handleOpen()

            }
        }
    },
    created() {
    },
    mounted() {
        if(this.speciality.realnessOpt.value === '0' && this.speciality.legalityOpt.value === '0' && this.speciality.relevanceOpt.value === '0') {
            this.speciality.isSpeciality = false
        } else {
            this.speciality.isSpeciality = true
        }

    //     let loginInfo = JSON.parse(getStore('loginUser'))
    //     this.loginMemberType = loginInfo.userRoles?loginInfo.userRoles[0]["roleCode"]:null
    //    this.curUserId = loginInfo.userInfo.userId

    },
    methods: {
        handleOpen(){
            // this.isMyself = myself
            // this.dialogVisible = true
            if(this.isRecord) {
                this.getOpinionList()
            } else {
                this.isSubmitedOpinion = false
            }
            // if(this.createRoomData.realnessType == '0' && this.createRoomData.legalityType == '0' && this.createRoomData.relevanceType == '0') {
            //     this.showRecord = false
            // } else
            // if(this.createRoomData.realnessType == null && this.createRoomData.legalityType == null && this.createRoomData.relevanceType == null&& !this.isWorker) {
            //     if(myself){
            //         this.showRecord = true
            //     } else {
            //         this.showRecord = false
            //     }
            // } else {
            //     this.showRecord = true
            // }
        },
        // enterRoom() { // websocket链接
        //     let roomId = this.createRoomData.roomId

        //     let self = this,
        //         hostName = config.hostName
        //     this.curroomid = roomId
        //     this.userToken = self.$route.query.token || getStore('flk');
        //     let ws = this.ws = new WebSocket('wss://' + hostName + '/gzzc/joinRoom?JWTToken=' + this.userToken + '&appName=' + config.appName + '&watcher=' + 'false')
        //     ws.onopen = function(evt) {
        //         self.ws.send(JSON.stringify({ event: 'JOIN_ROOM',data:{'roomId':roomId} }))
        //         self.listMessage(self.messagePageIndex);
        //     };
        //     ws.onmessage = function(evt) {
        //         let res = JSON.parse(evt.data)

        //         if (res.event == "LIST_MESSAGE") {
        //             self.loadMsgList(res.data)
        //         }
        //         if (res.event == "BROADCAST_MESSAGE") {
        //             if(res.data.roomId == self.curroomid){
        //                 if (Boolean(res.data.receiver)) {
        //                     self.uploadMsgList(res.data);
        //                 } else {
        //                     self.uploadMsgList(res.data)
        //                 }
        //             }
        //         }
        //         if (res.event == "HAND") {
        //             self.receiveHand(res.data)
        //         }
        //         if (res.event == "ERROR") {
        //             if (res.data['code'] == 1003) {
        //                 self.$alert(res.data['message'], '温馨提示', {
        //                     confirmButtonText: '确定',
        //                     confirmButtonClass: 'meeting_button_primary_small',
        //                     showClose: false,
        //                     customClass: 'meetbox',
        //                     callback: action => {
        //                         // history.back()
        //                     }
        //                 })
        //             }
        //             if (res.data['code'] == 9999) {
        //                 self.$alert(res.data['message'], '温馨提示', {
        //                     confirmButtonText: '确定',
        //                     confirmButtonClass: 'meeting_button_primary_small',
        //                     showClose: false,
        //                     customClass: 'meetbox',
        //                     callback: action => {
        //                         // history.back()
        //                     }
        //                 })
        //             } else if (res.data['code'] == 1002) {
        //                 self.$alert('请重新登录', '温馨提示', {
        //                     confirmButtonText: '确定',
        //                     confirmButtonClass: 'meeting_button_primary_small',
        //                     showClose: false,
        //                     customClass: 'meetbox',
        //                     callback: action => {
        //                         self.$router.push({
        //                             path: '/?goLogin',
        //                         })
        //                     }
        //                 })
        //             } else {
        //                 self.$alert(res.data['message'], '温馨提示', {
        //                     confirmButtonText: '确定',
        //                     confirmButtonClass: 'meeting_button_primary_small',
        //                     showClose: false,
        //                     customClass: 'meetbox',
        //                     callback: action => {}
        //                 })
        //             }
        //         }
        //         // self.messageListBody = self.$refs.messageListBox1;
        //         // console.log(self.$refs.messageListBox1.scrollHeight);
        //     };
        //     ws.onclose = function(evt) {
        //     }
        // },
        getOpinionList(){
            this.isSubmitedOpinion = true
            const {attachmentId, caseId, meetingId} = this.addEvidenceData
            evidenceList({
                attachmentId,
                caseId,
                bizRoomId: meetingId,
                meetingId
            }).then(res => {
                console.log("查看质证",res)
                if(res.data.code === 1000) {
                    let resData = res.data.data
                    this.opinionTable = resData
                }   else {
                    this.$message.error(res.data.message)
                }
            }).catch(err => {
                this.$message({
                    type: 'error',
                    message: err
                })
            })
        },
        onSendMessageClick() {
            if(!this.speciality.realnessOpt.value){
                 this.$message.warning('请选择真实性')
                 return;
            }
            if(!this.speciality.legalityOpt.value){
                 this.$message.warning('请选择合法性')
                 return;
            }
            if(!this.speciality.relevanceOpt.value){
                 this.$message.warning('请选择关联性')
                 return;
            }
            const {realnessOpt, legalityOpt, relevanceOpt} = this.speciality
            if(legalityOpt.value === '1' || realnessOpt.value === '1' || relevanceOpt.value === '1') {
                if (!this.inputMessage.length) {
                    this.$message.warning('请填写质证意见')
                    return;
                }
                if(this.inputMessage.indexOf('&') != -1 || this.inputMessage.indexOf('$') != -1 || this.inputMessage.indexOf('#') != -1){
                    this.$message.warning('质证意见包含特殊字符')
                    return;
                }
                let req = require('@/views/caseSpace/questionList/RGI_Emoji.js')()
                if(req.test(this.inputMessage)){
                    this.$message.warning('系统暂不支持emoji表情')
                    return;
                }
            }
            //提交质证
            if(!this.isRecord){
                if(this.btnSubmiting) return
                this.btnSubmiting = true
                const {attachmentId, caseId, meetingId} = this.addEvidenceData
                let params = {
                    attachmentId,
                    caseId,
                    legalityName: legalityOpt.label,
                    legalityType: legalityOpt.value,
                    meetingId,
                    realnessName: realnessOpt.label,
                    realnessType: realnessOpt.value,
                    relevanceName: relevanceOpt.label,
                    relevanceType: relevanceOpt.value,
                    opinion: this.inputMessage
                }
                console.log('params', params);
                addEvidence(params).then((res) => {
                    if(res.data.code === 1000) {
                        this.isRecord = true
                        this.getOpinionList()
                        this.$emit('successHandler')
                    } else {
                        this.$message.error(res.data.message)
                    }
                }).finally(()=>{
                    this.btnSubmiting = false
                })
            }
            // if(this.showRecord) {
            //     this.websocketSend()
            // }
            // this.showRecord = true
        },
        // websocketSend() {
        //     //质证发送websocket
        //     var self = this;
        //     var msg = this.inputMessage;
        //     self.inputMessage = "";
        //     var data = {
        //         'roomId': self.curroomid,
        //         content: msg,
        //         messageResource:'HANDLER_INPUT'
        //     };
        //     var msgdata = {};
        //     msgdata.event = "SEND_TEXT";
        //     msgdata.data = data;
        //     self.ws.send(JSON.stringify(msgdata))
        // },
        // uploadMsgList(message) {
        //     //聊天信息
        //     this.messagePageIndex = 1
        //     this.msgs.push({
        //         // who:"【"+this.meetingTypeEnum[message.sender.memberType]+"】"+(message.sender.memberType === 'MEDIATOR' ? '仲裁员': message.sender.memberName),
        //         who:"【"+this.meetingTypeEnum[message.sender.memberType]+"】"+message.sender.memberName,
        //         id:message.sender.memberId,
        //         content:message.messageContent,
        //         time:this.timestoday(message.createTime),
        //         type:message.messageResource
        //     })
        //     let context=document.getElementById('examinationBox')
        //     let t =setTimeout(function(){
        //         context.scrollTop=context.scrollHeight
        //     },500)
        // },
        // listMessage(pageindex) { // 拉取消息记录
        //     let self = this, data, msgdata = {};
        //     data = {
        //         'roomId': self.curroomid,
        //         pageIndex: 1,  //暂时改成1
        //         pageSize: 500
        //     };
        //     msgdata.event = "LIST_MESSAGE";
        //     msgdata.data = data;
        //     self.ws.send(JSON.stringify(msgdata))
        // },
        // pullMessage() {
        //     let self = this;
        //     this.messagePageIndex = 1
        //     if(self.$refs.messageListBox.scrollTop == 0&&self.messagePageIndex<=self.messageTotalPages&&self.messageListLoad){
        //         self.messageListLoad = false;
        //         self.listMessage(self.messagePageIndex);
        //     }
        // },
        // loadMsgList(data) {
        //     this.msgs = []
        //     this.messagePageIndex = 1
        //     if(!Boolean(data.list.length)) return;
        //     let self = this,  messagelist = [], context, t, messageListBody;
        //     self.messageListBody = messageListBody = document.querySelector('#examinationBox');
        //     self.messageListLoad = true;
        //     self.messagePageIndex = Number(self.messagePageIndex) + 1;
        //     self.messageTotalPages = data.totalPages;
        //     data.list.forEach((item,index,array) => {
        //         messagelist.unshift({
        //             // who:"【"+self.meetingTypeEnum[item.sender.memberType]+"】"+(item.sender.memberType === 'MEDIATOR' ? '仲裁员': item.sender.memberName),
        //             who:"【"+self.meetingTypeEnum[item.sender.memberType]+"】"+item.sender.memberName,
        //             id:item.sender.memberId,content:item.messageContent,time:this.timestoday(item.createTime),type:item.messageResource})
        //     });
        //     self.msgs = messagelist.concat(self.msgs);
        //     if(self.onceLoadMessage) {
        //         t = setTimeout(function(){self.messageListBody.scrollTop=self.messageListBody.scrollHeight},200)
        //         self.messageListBody.addEventListener('scroll', self.pullMessage, false);
        //     }
        //     self.onceLoadMessage = false;
        //     if(self.messagePageIndex>data.totalPages){
        //         self.messageListBody.removeEventListener('scroll', self.pullMessage, false);
        //     }
        // },
        // timestoday(t) {
        //     var times = new Date(t);
        //     var ty = times.getFullYear(), tm = times.getMonth()+1, td = times.getDate(), th = times.getHours(), tmt = times.getMinutes(), ts = times.getSeconds();
        //     var ntostring = function(d){
        //         if(d.toString().length ==1){
        //             return "0"+d;
        //         }
        //         return d;
        //     }
        //     return ntostring(th)+":"+ntostring(tmt)+":"+ntostring(ts);
        // },
        // handleGetName(options, Type) {
        //     //筛选质证参数
        //     var ret1 = options.find(item => {
        //         if(item.value === Type)
        //         return item.label
        //     })
        //     return ret1.label
        // },
        handleSpeciality(value) {
            // if(this.speciality.realnessOpt.value === '0' && this.speciality.legalityOpt.value === '0' && this.speciality.relevanceOpt.value === '0') {
            //     this.showRecord = false
            // } else {
            //     this.showRecord = true
            // }
        },
        handleClose(done) {
            this.speciality = {
                realnessOpt: {
                    value: '0',
                    label: '真实'
                },
                legalityOpt: {
                    value: '0',
                    label: '合法'
                },
                relevanceOpt: {
                    value: '0',
                    label: '关联'
                }
            }
            this.$emit('comcallback');
            // this.ws.close();
            this.dialogVisible = false
            // done();
        },
        //删除质证意见
        deleteZ(row){
            console.log('删除-----',row)
            let params = {
                meetingId:row.meetingId,
                caseId:row.caseId,
                userId:row.userId,
                id:row.id
            }
            this.$confirm(
                    '是否确认删除该质证意见?',
                    "提示", {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        customClass: "close-mediate-room",
                        dangerouslyUseHTMLString: true,
                        center: true,
                    }
                ).then(() => {
                      delEvidence(params).then(res => {
                          console.log('res----',res,res.data)
                          if(res.data.code == 1000){
                            this.getOpinionList()
                          }
                      }).catch(err => {
                         this.$message.warning('删除失败')
                      })
                }).catch( () => {})
           
        }
    }
}
</script>

<style lang="scss">
    .crossExamination {
        .big-title {
            text-align:center;
            font-size: 18px;
        }
        .text-info {
            margin-top: 10px;
            margin-bottom: 15px;
            font-size: 14px;
        }
        .icon-check{
            width: 17px;
            display: inline-block;
            background: url('~@/assets/opinion-check.png') no-repeat center;
            background-size: 100%;
            height: 12px;
            &.uncheck{
                width: 12px;
                background: url('~@/assets/opinion-uncheck.png') no-repeat center;
            }
        }
        .el-dialog__header {
            border-bottom: 1px solid #e5e5e5;
            .el-dialog__title {
                margin-left: 10px;
            }
        }
        .inneExaminationr {
            .topExamination {
                padding-bottom: 30px;
                .nocrossExamination {
                    display: flex;
                    align-items: center;
                    justify-content: space-evenly;
                    .el-select {
                        width: 140px;
                    }
                }
                .yescrossExamination {
                    display: flex;
                    align-items: center;
                    justify-content: space-evenly;
                    .col {
                        color: #999999;
                        span {
                            color: #333333;
                        }
                    }
                }
            }
            .inne-tip {
                color: #000000;
                width: 90%;
                margin: 0 auto 30px;
            }
            .contentExamination {
                .privatchat_main-title {
                    // padding-top: 30px;
                }
                .privatchat_main1 {
                    position: relative;
                    // height: 350px;
                    .currentChatMember {
                        position: absolute;
                        top: 0;
                        left: 0;
                        right: 0;
                        height: 25px;
                        line-height: 25px;
                        text-align: center;
                        font-size: 14px;
                        color: #0083c8;
                        background-color: #fff;
                    }
                    .chat-message_list {
                        // position: absolute;
                        // top: 25px;
                        // bottom: 125px;
                        // left: 0;
                        // right: 0;
                        // margin: 0;
                        height: 200px;
                        margin-bottom: 10px;
                        padding: 20px;
                        border-radius: 2px;
	                    border: solid 1px #e6e6e6;
                        box-sizing: border-box;
                        overflow-y: auto;
                        li {
                            padding: 10px 0 15px;
                            span {
                                display: block;
                                padding-bottom: 6px;
                                color: #888888;
                                font-size: 14px;
                            }
                            div.infobackground {
                                position: relative;
                                display: inline-block;
                                padding: 10px 15px;
                                line-height: 22px;
                                color: #494949;
                                font-size: 14px;
                                background-color: #f7f7f7;
                                border: 1px solid #f0f0f0;
                                border-radius: 2px;
                                text-align: left;
                            }
                        }
                        li.meeting-chatroom-self {
                            text-align: right;
                            div.infobackground {
                                color: #333333;
                                background-color: #f7f7f7;
                                border: 1px solid #f7f7f7;
                            }
                        }
                        .no_list {
                            img {
                                display: block;
                                margin: 40px auto 0;
                            }
                        }
                    }
                    .chat-message_speaking {
                        // position: absolute;
                        // left: 0;
                        // right: 0;
                        // bottom: 10px;
                        height: 80px;
                        padding: 10px;
                        background-color: #ffffff;
                        border-radius: 2px;
	                    border: solid 1px #e6e6e6;
                        .input-textarea {
                            font-size: 12px;
                            width: 100%;
                            height: 80px;
                            display: inline-block;
                            padding: 5px 10px;
                            border: none;
                            color: #494949;
                            background-color: #ffffff;
                            resize: none;
                            outline: 0;
                            -webkit-appearance: none;
                            -webkit-box-sizing: border-box;
                            box-sizing: border-box;
                            -webkit-transition: all .3s cubic-bezier(.645,.045,.355,1);
                            -webkit-transition: all .3s cubic-bezier(0.65, 0.05, 0.36, 1);
                            transition: all .3s cubic-bezier(0.65, 0.05, 0.36, 1);
                        }
                        .input-textarea::-webkit-input-placeholder {
                            color: #ccc;
                            font-size: 14px;
                        }
                    }
                }
                .chat-message_btnSend {
                    display: inline-block;
                    vertical-align: top;
                    text-align: center;
                    width: 100%;
                    padding-top: 20px;
                    button {
                        width: 150px;
                        height: 46px;
                        border-radius: 4px;
                        color: #fff;
                        border: none;
                        outline: 0;
                        background-color: #0083c8;
                        box-shadow: 0 5px 8px 0 rgba(0, 117, 206, 0.25);
                        cursor: pointer;
                    }
                }
            }
        }
    }
</style>
